//Types
import { CDCInfo } from 'types/cdc'
import { DocsetInfo as Docset } from 'types/docset'

export const isAdvSearch = (inputQuery: string):boolean => {
  if(inputQuery) {
    if (inputQuery.indexOf("_") !== -1 ||
        inputQuery.indexOf("$") !== -1 ||
        inputQuery.indexOf("&") !== -1 ||
        inputQuery.indexOf("|") !== -1 ||
        inputQuery.indexOf("%") !== -1 ||
        inputQuery.indexOf("^") !== -1 ||
        inputQuery.indexOf("~") !== -1 ||
        inputQuery.indexOf("OR") !== -1 ||
        inputQuery.indexOf("AND") !== -1 ||
        inputQuery.indexOf("NOT") !== -1 ||
        inputQuery.indexOf("*") !== -1 ||
        inputQuery.indexOf("?") !== -1 ||
        inputQuery.indexOf("ＡＮＤ") !== -1 ||
        inputQuery.indexOf("ＯＲ") !== -1 ||
        inputQuery.indexOf("ＮＯＴ") !== -1 ||
        inputQuery.indexOf("＊") !== -1 ||
        inputQuery.indexOf("？") !== -1 ||
        inputQuery.indexOf("”") !== -1 ||
        inputQuery.indexOf("\"") !== -1
    ) {
        return true;
    } else {
        return false;
    }
  }else {
      return false;
  }
}

// WARNING: This is not a drop in replacement solution and
// it might not work for some edge cases. Test your code! 
// This is a simplified implementation
// of https://youmightnotneed.com/lodash#unionBy
// which would work with only one array
const uniqBy = (arr:any, iteratee:any) => {
  if (typeof iteratee === 'string') {
    const prop = iteratee
    iteratee = function(item:any){return item[prop]}
  }

  return arr.filter(
    (x:any, i:any, self:any) => i === self.findIndex(function(y:any){return iteratee(x) === iteratee(y)})
  )
}

export const collectionDocsets = (cdcs:CDCInfo[]): Docset[] => {
  let docsets = uniqBy(cdcs.map(cdc => {
      return cdc.docsetCollection ? cdc.docsetCollection.docsets ? cdc.docsetCollection.docsets : [] : []
    }).flat().filter(e=>e), 'id')
  return docsets
}